import React from 'react';
import {
  FUNDING_CLAWBACK_RISKS,
  FUNDING_COMMISSION_STATUSES,
  FUNDING_PAYOUT_STATUSES,
} from '../../utils/funding/constants';

const selectClass = 'rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20';

const FundingCommissionFilters = ({
  search,
  status,
  payoutStatus,
  clawbackRisk,
  assignedUserId,
  payoutDueFrom,
  payoutDueTo,
  onSearchChange,
  onStatusChange,
  onPayoutStatusChange,
  onClawbackRiskChange,
  onAssignedUserChange,
  onPayoutDueFromChange,
  onPayoutDueToChange,
}) => (
  <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
    <input
      type="search"
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      placeholder="Search client, lender, deal..."
      className="rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20 xl:col-span-2"
    />
    <select value={status} onChange={(e) => onStatusChange(e.target.value)} className={selectClass}>
      <option value="">All statuses</option>
      {FUNDING_COMMISSION_STATUSES.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    <select value={payoutStatus} onChange={(e) => onPayoutStatusChange(e.target.value)} className={selectClass}>
      <option value="">All payout statuses</option>
      {FUNDING_PAYOUT_STATUSES.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    <select value={clawbackRisk} onChange={(e) => onClawbackRiskChange(e.target.value)} className={selectClass}>
      <option value="">All clawback risk</option>
      {FUNDING_CLAWBACK_RISKS.map((item) => <option key={item} value={item}>{item}</option>)}
    </select>
    <input
      type="text"
      value={assignedUserId}
      onChange={(e) => onAssignedUserChange(e.target.value)}
      placeholder="Assigned user ID"
      className="rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20"
    />
    <input type="date" value={payoutDueFrom} onChange={(e) => onPayoutDueFromChange(e.target.value)} className={selectClass} />
    <input type="date" value={payoutDueTo} onChange={(e) => onPayoutDueToChange(e.target.value)} className={selectClass} />
  </div>
);

export default FundingCommissionFilters;
